module.exports = __webpack_public_path__ + "media/move.19d64d40.mp3";